import $ from 'jquery';

class Navigation {
	constructor() {
		this.body = $('body');
		this.nav = $('#nav');
		this.navContainer = $('#navContainer');

		$('#navToggle').on('click', this.toggleMenu);
	}

	toggleMenu = () => {

		this.toggleMenuCommon();
		if (this.nav.hasClass('opened')) {
			$('.nav__box').fadeIn(500);
			$('.nav__box .container').addClass('hidden');
		} else {
			$('.nav__box').fadeOut(500);
			$('.nav__box .container').removeClass('hidden');
		}

	};

	toggleMenuCommon = () => {
		this.nav.toggleClass('opened');
		this.navContainer.toggleClass('active');
	};
}

new Navigation();
